import React from 'react';
import { TableCell } from '@material-ui/core';
import Block from '../../../../../assets/svg/block';
import '../../shared/Table.css';

const DisabledCell = () => (
  <TableCell className='disabled-cell'>
    <div className='flex-rows' style={{ justifyContent: 'center', alignItems: 'center' }}>
      <Block fill='#A4AFB7' />
    </div>
  </TableCell>
);

export default DisabledCell;
